import React from 'react';
import { Play, Zap, Download, Clock } from 'lucide-react';

export const Hero: React.FC = () => {
  return (
    <div className="relative bg-gradient-to-br from-blue-50 via-white to-green-50 min-h-screen">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_25%_25%,rgba(74,144,226,0.1)_0%,transparent_50%)] pointer-events-none"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-16">
        {/* Header */}
        <header className="flex items-center justify-between mb-20">
          <div className="flex items-center space-x-2">
            <Zap className="w-8 h-8 text-blue-500" />
            <span className="text-2xl font-bold text-gray-900">SummarizeAI</span>
          </div>
          <nav className="hidden md:flex space-x-8">
            <a href="#features" className="text-gray-600 hover:text-blue-500 transition-colors">Features</a>
            <a href="#how-it-works" className="text-gray-600 hover:text-blue-500 transition-colors">How it Works</a>
            <a href="#pricing" className="text-gray-600 hover:text-blue-500 transition-colors">Pricing</a>
          </nav>
        </header>

        {/* Hero Content */}
        <div className="text-center max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold text-gray-900 mb-8 leading-tight">
            Transform
            <span className="bg-gradient-to-r from-blue-500 to-green-500 bg-clip-text text-transparent"> YouTube Videos </span>
            into Smart Summaries
          </h1>
          
          <p className="text-xl text-gray-600 mb-12 max-w-2xl mx-auto leading-relaxed">
            Save hours of viewing time. Get AI-powered summaries with synchronized transcripts 
            and downloadable content from any YouTube video.
          </p>

          {/* Feature Pills */}
          <div className="flex flex-wrap justify-center gap-4 mb-16">
            <div className="flex items-center space-x-2 bg-white/70 backdrop-blur-sm rounded-full px-4 py-2 shadow-sm border border-white/50">
              <Clock className="w-4 h-4 text-blue-500" />
              <span className="text-sm font-medium text-gray-700">10x Faster Learning</span>
            </div>
            <div className="flex items-center space-x-2 bg-white/70 backdrop-blur-sm rounded-full px-4 py-2 shadow-sm border border-white/50">
              <Play className="w-4 h-4 text-green-500" />
              <span className="text-sm font-medium text-gray-700">Smart Summarization</span>
            </div>
            <div className="flex items-center space-x-2 bg-white/70 backdrop-blur-sm rounded-full px-4 py-2 shadow-sm border border-white/50">
              <Download className="w-4 h-4 text-coral-500" />
              <span className="text-sm font-medium text-gray-700">Multiple Formats</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};